"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollAnchor = void 0;
const react_1 = __importDefault(require("react"));
const ThreadContext_1 = require("../../../ThreadContext");
/**
 * Presentational empty div which can be added within the Thread component
 * Once Thread component is loaded, it will scroll to where this anchor is placed
 *
 * If multiple ScrollAnchor components are added within the Thread, the last one
 * will be the one to scroll to
 */
const ScrollAnchor = () => {
    const { scrollAnchorRef } = (0, ThreadContext_1.useThread)();
    return react_1.default.createElement("div", { role: "presentation", ref: scrollAnchorRef });
};
exports.ScrollAnchor = ScrollAnchor;
//# sourceMappingURL=ScrollAnchor.js.map